import AES from "crypto-js/aes";
import Hex from "crypto-js/enc-hex";
import Utf8 from "crypto-js/enc-utf8";


// Do not change this value - ever.
const KEY ='000102030405060708090a0b0c0d0e0f';

// Do not change this value - ever.
const SALT = { salt: Hex.parse("4521F86027413403") };

export default {
    scramble(val) {
        var scrambled = AES.encrypt(val, KEY, SALT);
        return encodeURIComponent(scrambled.toString());
    },

    descramble(val) {
        var decoded = decodeURIComponent(val);
        return AES.decrypt(decoded, KEY, SALT).toString(Utf8);
    }
}
